<template>
  <div class="merchant-list-wrap">
    <div v-if="buyGoodsList.length > 0">
      <h3 class="text-bold-c111 font-s20 mt-24 mb-24 mlr">
        {{ TLang("确认商家信息和配送方式", "orderConfirm") }}
      </h3>
      <!-- 遍历商户 -->
      <div v-for="merchantItem in buyGoodsList" :key="merchantItem.id">
        <div class="mt-16 ml-24 mr-24 clearfix">
          <div class="fl">
            <img src="@assets/images/order/shop-icon.png" />
            <span>{{ merchantItem.merchantAlias }}</span>
          </div>
        </div>
        <div
          v-for="warehouseItem in merchantItem.warehouseList"
          :key="warehouseItem.id"
        >
          <productsList
            :productList="warehouseItem.goodsList"
            :warehouseIndex="warehouseItem.index"
            :warehouseId="warehouseItem.warehouseId"
            :warehouseNo="warehouseItem.warehouseNo"
            :fppConfigure="fppConfigure"
            :unionIcon="union_icon || require('@/assets/images/fudou.png')"
            @onResetDeliveryWay="
              (birthdayInfoList) => {
                warehouseItem.birthdayInfoList = birthdayInfoList;
                const deliveryInfoItem = {
                  index: warehouseItem.index,
                  merchantId: merchantItem.merchantId,
                  warehouseId: warehouseItem.warehouseId,
                  ...warehouseItem.deliveryWay,
                  ...birthdayInfoList,
                }
                onChangeDeliveryWay({
                  deliveryInfoItem: JSON.parse(JSON.stringify(deliveryInfoItem)),
                });
              }
            "
          />

          <div class="order-tfooter card-default clearfix prelative">
            <delivery-way
              :deliveryInfo="warehouseItem.deliveryInfo"
              :deliveryInfo_1_list="deliveryInfo_1_list"
              :warehouseItem="warehouseItem"
              :epidemicDeliverInfo="epidemicDeliverInfo"
              @getDelivery_1_options="(date) => {getDelivery_1_options(date,merchantItem.merchantNo, warehouseItem.warehouseNo)}"
              @onResetDeliveryWay="
                (deliveryWay) => {
                  warehouseItem.deliveryWay = deliveryWay;
                  const { userRemark } = warehouseItem;
                  const deliveryInfoItem = !userRemark
                    ? {
                        index: warehouseItem.index,
                        merchantId: merchantItem.merchantId,
                        warehouseId: warehouseItem.warehouseId,
                        birthdayInfoList: getBirthdayInfoList(warehouseItem.goodsList) || warehouseItem.deliveryInfo.birthdayInfoList,
                        ...deliveryWay,
                      }
                    : {
                        index: warehouseItem.index,
                        merchantId: merchantItem.merchantId,
                        warehouseId: warehouseItem.warehouseId,
                        birthdayInfoList: getBirthdayInfoList(warehouseItem.goodsList) || warehouseItem.deliveryInfo.birthdayInfoList,
                        ...deliveryWay,
                        ...warehouseItem.userRemark,
                      };

                  onChangeDeliveryWay({
                    deliveryInfoItem: deliveryInfoItem,
                  });
                }
              "
            ></delivery-way>
            <!-- 普通配送/精准配送/指定日期配送 -->
            <div class="order-tfooter-item deliverTotal">
              <!-- <span class="font-c666">
                {{ TLang("配送方式", "orderConfirm") }}
              </span>
              <span
                v-if="warehouseItem.deliveryInfo.deliveryWay === '1'"
                class="text"
              >
                {{ TLang("精准配送", "orderConfirm") }}
              </span>
              <span
                v-if="warehouseItem.deliveryInfo.deliveryWay === '2'"
                class="text"
              >
                {{ TLang("普通配送", "orderConfirm") }}
              </span>
              <span
                v-if="warehouseItem.deliveryInfo.deliveryWay === '3'"
                class="text"
              >
                {{ TLang("指定日期发货", "orderConfirm") }}
              </span> -->
            </div>
            <div class="order-tfooter-item mt-12">
              <span class="font-c666"
                ><span
                style="width:200px"
                  >（{{
                    warehouseItem.freight > 0
                      ? ReplaceText(
                          "XXX",
                          Number(warehouseItem.freight * union_scale).toFixed(
                            2
                          ),
                          TLang("含运费", "orderConfirm")
                        )
                      : TLang("已免运费", "orderConfirm")
                  }}）</span
                >
                <!-- {{ TLang("共", "orderConfirm") }} -->
                <em class="font-s14">{{ warehouseItem.totalNum }}</em>
                {{ TLang("件商品", "orderConfirm") }}，{{
                  TLang("小计", "orderConfirm")
                }}:
              </span>
              <!-- <span v-if="fppConfigure.groupItem === 'Y'">
                <em class="text-num-bold-c111">{{
                  (
                    parseFloat(warehouseItem.totalPrice || 0) +
                    parseFloat(Number(warehouseItem.freight * union_scale))
                  ).toFixed(2)
                }}</em>
              </span> -->
              <span>
                <img
                  v-if="fppConfigure && fppConfigure.groupItem !== 'Y'"
                  :src="union_icon || require('@/assets/images/fudou.png')"
                  alt="fudou"
                  class="fudou-15"
                />
                <em class="text-num-bold-c111">{{fppConfigure && fppConfigure.groupItemShowRmbSymbol === 'Y'?'&#65509;':''}}{{
                  (
                    parseFloat(warehouseItem.totalPrice) +
                    parseFloat(Number(warehouseItem.freight * union_scale))
                  ).toFixed(2)
                }}</em>
              </span>
            </div>
          </div>
          <!-- 新配件区域 -->
          <PartsSelect
            v-if="warehouseItem.chargeAnnexList && warehouseItem.chargeAnnexList.length > 0"
            :data="warehouseItem.chargeAnnexList"
            :warehouseItem="warehouseItem"
            :onModifyNum="onReload"
            :choosePartsLoading="choosePartsLoading"
          />

          <!-- merchantAccessoryDto 生日会页面配置 -->
          <!-- <BirthdayParts
            v-if="
              !!merchantItem.merchantAccessoryDto &&
              merchantItem.merchantAccessoryDto.accessoryGroups.length > 0 &&
              warehouseItem.accessoryFlag
            "
            :accessoryGroups="merchantItem.merchantAccessoryDto.accessoryGroups"
            :merchantId="merchantItem.merchantId"
            @onResetDeliveryWay="
              (userRemark) => {
                warehouseItem.userRemark = userRemark;
                onChangeDeliveryWay({
                  deliveryInfoItem: {
                    index: warehouseItem.index,
                    merchantId: merchantItem.merchantId,
                    warehouseId: warehouseItem.warehouseId,
                    ...warehouseItem.deliveryWay,
                    ...userRemark,
                  },
                });
              }
            "
          /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import productsList from "../../../components/productsList";
import PartsSelect from  "../../../components/partsSelect";
import BirthdayParts from "../birthdayParts";
import deliveryWay from "../deliveryWay";
import { mapActions } from "vuex";
import { POST_getPreciseDeliveryTime} from '@fetch/order';
import { getDateStr } from '@utils';

export default {
  name: "MerchantList",
  components: {
    productsList,
    deliveryWay,
    BirthdayParts, // 生日配件
    PartsSelect, // 付费配件
  },
  props: {
    buyGoodsList: Array,
    fppConfigure: Object,
    epidemicDeliverInfo: {
      type: Object,
      default: function () {
        return {
          allowDelivery: null,
          mandatoryType: null,
          promptWords: null,
        };
      },
    },
    handlePartsNum: Function,
    choosePartsLoading: Boolean,
  },
  created(){
    // console.log("buyGoodsList", this.buyGoodsList, this.fppConfigure);

  },
  data() {
    return {
      deliveryInfo_1_list: [],
    };
  },
  methods: {
    ...mapActions("orderConfirm", ["onChangeDeliveryWay"]),
    onReload(info, num, type, warehouseItem) {
      // this.$parent.initData();
      this.handlePartsNum(info, num, type, warehouseItem);
    },
    getDelivery_1_options(date,merchantNo, warehouseNo) {
      POST_getPreciseDeliveryTime({day:getDateStr(0,date), merchantNo, warehouseNo}).then((res) =>{
        if(!Array.isArray(res.data )) return;
        this.deliveryInfo_1_list = res.data.map(item => {
          return {
            label: item,
            value: item,
            disabled: false,
          };
        });
      });
    },
    getBirthdayInfoList(goodsList){
      let birInfoList = [{
        goodsList: [],
        index: 0,
        warehouseId: 0,
        warehouseNo: '',
      }];
      let newBirthdayInfoList = null;
      goodsList &&
        goodsList.map(item => {
          const sessionBirthdayInfoList = JSON.parse(window.sessionStorage.getItem('birthdayInfoList')) || [];
          if (sessionBirthdayInfoList && sessionBirthdayInfoList.length > 0) {
            sessionBirthdayInfoList.forEach(a => {
              a.goodsList && a.goodsList.length > 0 && a.goodsList.forEach(b => {
                if (b.categoryId == item.categoryId && b.goodsId == item.goodsId) {
                  birInfoList[0].index = a.index;
                  birInfoList[0].warehouseId = a.warehouseId;
                  birInfoList[0].warehouseNo = a.warehouseNo;
                  birInfoList[0].goodsList.push({
                    goodsId: item.goodsId,
                    categoryId: item.categoryId,
                    birthdayRemark: b.birthdayRemark,
                  });
                  newBirthdayInfoList = birInfoList;
                }
              });
            });
            return newBirthdayInfoList;
          } else {
            return newBirthdayInfoList;
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.order-thead,
.order-tbody > div.order-tbody-item {
  & > :nth-of-type(1) {
    width: 46.17%;
  }
  & > :nth-of-type(2) {
    width: 23.75%;
  }
  & > :nth-of-type(3) {
    width: 18%;
  }
  & > :nth-of-type(4) {
    width: 123px;
    text-align: right;
  }
}
.order-thead {
  padding: 12px 24px;
}
.order-tfooter {
  padding: 24px 24px 16px;

  // 重置下拉筛选样式
  .el-select {
    width: 240px;
    height: 28px;

    /deep/ .el-input__inner {
      border-radius: 0;
      height: 28px;
      line-height: 28px;

      &::placeholder {
        font-size: 12px;
        color: #ccc;
      }
    }

    /deep/ .el-input__icon {
      width: 25px;
      height: 28px;
      line-height: 28px;
    }
  }

  .order-tfooter-item {
    text-align: right;
    span {
      display: inline-block;
      width: calc(100% - 230px);
      &:last-of-type {
        width: 200px;
        text-align: right;
      }
    }
  }
  .deliverTotal {
    // padding-top: 12px;
    border-top: 1px dashed #e5e5e5;
  }
}
</style>
